import * as React from 'react';
import { DataGrid, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';


import Grid from '@mui/material/Grid';

import CircularProgressLabel from './CircularProgressLabel.js';

const columns = [
  { field: 'fr', headerName: 'Word', width: 150 },
  { field: 'word', headerName: 'Definition', width: 150 },
  {
  	headerName: 'Familiarity',
    field: 'familiarity',
    width: 100,
    renderCell: (cellValues) => {
    	return (
    		<Grid sx={{align:'center'}}>
    			<CircularProgressLabel value={cellValues.row.familiarity}/>
    		</Grid>
    	)
    }
  }
];

const rows = [
  { id: 1, word: 'Snow', definition: 'Jon', familiarity: 35, include: true },
  { id: 2, word: 'Lannister', definition: 'Cersei', familiarity: 42, include: true },
];

function WordTable(props) {

  React.useEffect(() => {
    // console.log("props.sm is", props.sm)
  }, []);

  const [selectionModel, setSelectionModel] = React.useState(props.sm);

  return (
    <div style={{ height: 400, width: '100' }}>
      <DataGrid
        rows={props.currentWordList}
        columns={columns}
        pfamiliaritySize={10}
        rowsPerPfamiliarityOptions={[10]}
        checkboxSelection
        autoPfamiliaritySize
        selectionModel={props.sm}
        onSelectionModelChange={(ids) => {
          setSelectionModel(ids);
          props.setSelectionModel(ids);
        }}
      />
    </div>
  );
}

export default WordTable